import React from 'react';
import './style.scss';

export default ({ title, text }) => (
  <div className="message-line">
    <div className="message-line__inner">
      <div className="message-line__icon" />
      {title ? (
        <div className="message-line__title" dangerouslySetInnerHTML={{ __html: title || '' }} />
      ) : null}
      {text ? (
        <div className="message-line__text" dangerouslySetInnerHTML={{ __html: text || '' }} />
      ) : null}
    </div>
  </div>
);




// WEBPACK FOOTER //
// ./src/components/lineMessage/index.js